import { useEffect } from 'react';

import axios from 'axios';
import ErrorState from 'components/layout/error-state/error-state';
import LoadingOlist from 'components/layout/loading-olist';
import LeadsHeader from 'pages/leads/components/leads-header/leads-header';
import { QualificationContext } from 'pages/leads/components/qualification-context';
import RevenuesContainer from 'pages/leads/components/revenues/revenues-container/revenues-container';
import { API_URLS } from 'pages/leads/constants';
import { useAsyncFn } from 'react-use';

import { Container } from '@olist/templates';
import { Flex } from '@olist/united';

import { RevenueProps } from './revenues-page.types';

const RevenuesPage = () => {
  const [{ error, loading, value: revenuesResponse }, fetchRevenuesData] = useAsyncFn(async () => {
    return axios.get(API_URLS.getRevenues) as any;
  }, []);

  const revenuesData: RevenueProps[] = revenuesResponse?.data?.results || null;

  useEffect(() => {
    fetchRevenuesData();
  }, [fetchRevenuesData]);

  if (error) {
    return (
      <Flex height="100vh" justifyContent="center" alignItems="center">
        <ErrorState onClick={() => window.location.reload()} />
      </Flex>
    );
  }

  if (loading || !revenuesResponse) {
    return <LoadingOlist data-testid="revenue-loading-olist" />;
  }

  return (
    <QualificationContext.Provider
      value={{
        revenues: revenuesData,
      }}
    >
      <Container>
        <LeadsHeader currentStep={LeadsHeader.steps.REQUIREMENTS} />
        <Flex alignItems="left" flexDirection="column" mt={2} mx={1}>
          <RevenuesContainer />
        </Flex>
      </Container>
    </QualificationContext.Provider>
  );
};

export default RevenuesPage;
